<template lang="pug">
.ui-timepicker-spin
  UiButton(
    variant="smooth-secondary"
    round
    icon="ChevroneTop"
    @click="spinUp()"
    size="sm"
  )
  .ui-timepicker-spin__label {{ displayValue }}
  UiButton(
    variant="smooth-secondary"
    round
    icon="ChevroneBottom"
    @click="spinDown()"
    size="sm"
  )
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
  },

  computed: {
    value() {
      if (typeof this.modelValue !== "number") return this.min;
      if (this.modelValue < this.min) return this.min;
      if (this.modelValue > this.max) return this.max;
      return this.modelValue;
    },

    displayValue() {
      return String(this.value).padStart(2, "0");
    },
  },

  methods: {
    spinUp() {
      let newValue;
      if (this.modelValue >= this.max) {
        newValue = this.min;
      } else {
        newValue = this.modelValue + 1;
      }
      this.$emit("update:modelValue", newValue);
    },
    spinDown() {
      let newValue;
      if (this.modelValue <= this.min) {
        newValue = this.max;
      } else {
        newValue = this.modelValue - 1;
      }
      this.$emit("update:modelValue", newValue);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheet/_variables.scss";
@import "@/assets/stylesheet/_form.scss";

.ui-timepicker-spin {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
</style>
